import React from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import AssignQuotePopupNewCustomerInput from "./assignQuotePopupNewCustomerInput";
import AssignQuotePopupNewCustomerSelect from "./assignQuotePopupNewCustomerSelect";
import {HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS, PREFERRED_COMMUNICATION_METHODS} from "./assignQuoteConstants";
import AssignPopupContext from './assignPopupContext';
import LookUserPhoneInput from "../../look/user/lookUserPhoneInput";
import {IS_LIXIL_SERVERS, IS_LOOK_JOURNEY} from "../../../config";
import LookUserInput from "../../look/user/lookUserInput";

const getSelectFields = () => {
  return IS_LIXIL_SERVERS ? {
    "preferredCommunicationMethod": {
      placeholder: "assignPopup.newCustomer.placeholders.preferedCommunicationMethod",
      options: PREFERRED_COMMUNICATION_METHODS
    },
  } : {
    "howDidYouHearAboutUs": {
      placeholder: "assignPopup.newCustomer.placeholders.howQuestion",
      options: HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS
    },
  }
}

const AssignQuotePopupNewCustomer = (props) => {

  const {isActive, fabricatorData} = props;
  const inputFields = {
    "firstName": "assignPopup.newCustomer.placeholders.firstName",
    "lastName":  "assignPopup.newCustomer.placeholders.lastName",
    "phoneNumber": "assignPopup.newCustomer.placeholders.phoneNumber1",
    "phone2":    "assignPopup.newCustomer.placeholders.phoneNumber2",
    "address1":  "assignPopup.newCustomer.placeholders.address1",
    "city":     fabricatorData.isCaesarStone ? "assignPopup.newCustomer.placeholders.address2" : "assignPopup.newCustomer.placeholders.city",
    "state":    "assignPopup.newCustomer.placeholders.state",
    "postal":    fabricatorData.isLowes ? "assignPopup.newCustomer.placeholders.postalLowes" : "assignPopup.newCustomer.placeholders.postal",
    "email":     "assignPopup.newCustomer.placeholders.email",
  };
  // if (!fabricatorData.isCaesarStone) {
  //   delete inputFields["state"];
  // }
  const selectFields = getSelectFields(fabricatorData);

  return (
    <div className={"ass ass--new" + (isActive ? " ass--active" : "")}>
      <div className="ass-fields">
        {Object.keys(inputFields).map((property, propertyIndex) => {
          return (
            <AssignPopupContext.Consumer key={propertyIndex}>
              {/*{({context, setContext}) => (*/}
              {({inputsValidated}) => {
                if (IS_LOOK_JOURNEY) {
                  return (
                    <div className="ass-field">
                      {(property === "phoneNumber") ? (
                        <LookUserPhoneInput
                          isActive={isActive}
                          className={"u-mb-0"}
                          inputsValidated={inputsValidated}
                          property={property}
                          placeholder={inputFields[property]}
                        />
                      ) : <LookUserInput property={property}
                                         className={"u-mb-0"}
                                         inputsValidated={inputsValidated} />}
                    </div>
                  )
                }
                return (property === "phoneNumber") ? (
                  <LookUserPhoneInput
                    isActive={isActive}
                    inputsValidated={inputsValidated}
                    property={property}
                    placeholder={inputFields[property]}
                  />
                ) : (
                  <AssignQuotePopupNewCustomerInput
                    isActive={isActive}
                    inputsValidated={inputsValidated}
                    property={property}
                    placeholder={inputFields[property]}
                  />
                )
              }}
            </AssignPopupContext.Consumer>
          )
        })}
        {Object.keys(selectFields).map((property, propertyIndex) => {
          return (
            <AssignQuotePopupNewCustomerSelect
              key={propertyIndex}
              property={property}
              select={selectFields[property]}
            />
          )
        })}
      </div>
    </div>
  )
};

AssignQuotePopupNewCustomer.propTypes = {
  isActive: PropTypes.bool.isRequired,
  switchToContract: PropTypes.func,
};

const mapStateToProps = (store) => {
  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomer)

